module.exports = __webpack_public_path__ + "img/return-icon.db55a209.svg";